{
  "label_clear": "Очистить",
  "label_show-error-info": "Показать попап с информацей об ошибке"
}
